export default __webpack_public_path__ + "static/media/Appointment-of-Statutory-Auditors.3f05da6b.pdf";